<template>
    <main>
        <div
            class="graphics-box graphics-box--01 rellax"
            data-rellax-speed="2"
        ></div>
        <div
            class="graphics-box graphics-box--02 rellax"
            data-rellax-speed="2"
        ></div>
        <div
            class="graphics-box graphics-box--03 rellax"
            data-rellax-speed="2"
        ></div>
        <div
            class="graphics-box graphics-box--04 rellax"
            data-rellax-speed="2"
        ></div>
        <div class="container-blog">
            <h1 class="page-title">
                {{ $t("other_woutlog.blog_text_1") }}
                <span>{{ $t("other_woutlog.blog_text_2") }}</span>
            </h1>
            <div class="blog-list">
                <blog-card
                    v-for="article in articles"
                    :key="article.id"
                    :article="article"
                />
            </div>
        </div>
    </main>
</template>

<script>
import BlogCard from "./BlogCard.vue";
export default {
    props: ["articles"],
    components: { BlogCard },
};
</script>
<style lang="scss" scoped></style>
